<script setup lang="ts">
definePageMeta({
  title: "キャンパスマップ",
})
</script>

<template>
  <article class="flex flex-col items-center max-w-[900px] mx-auto px-[8px] my-4 h-[calc(100svh-64px)] md:h-[auto]">
    <div class="flex-grow md:flex-grow-0 mb-4 overflow-x-scroll md:overflow-x-auto max-w-full ">
      <NuxtImg class="max-h-full max-w-[none] md:max-h-none md:w-full" format="webp" src="/img/map.jpg" decoding="async"
        loading="lazy" />
    </div>

    <div class="mb-4 md:mb-0">
      <NuxtLink class="btn btn-primary" to="/pdf/map.pdf" target="_blank">
        マップをPDFで開く
      </NuxtLink>
    </div>
  </article>
</template>